export default "__VITE_ASSET__BsNgtD5t__"